module.exports = __webpack_public_path__ + "img/ball.63733d6a.png";